// apps/client/src/ui/kit/TitleTab.tsx
import type { ReactNode } from 'react';
export function TitleTab(p: { color?: string; children: ReactNode }) {
  return <div className="title-tab" style={p.color ? { background: p.color } : undefined}>{p.children}</div>;
}
